import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const bottomActions = css`
  flex-wrap: inherit;
`;

export const modalContainerForPdf = css`
  max-height: 100svh;
  @media only screen and (min-width: ${dimensions.tablet}) {
    min-height: 35rem;
  }
`;

export const centerTitle = css`
  text-align: center;
`;

export const footerText = css`
  margin-right: 1rem;
  @media only screen and (min-width: ${dimensions.tablet}) {
    margin-right: 3.75rem;
  }
`;

export const agreeButton = css`
  max-width: 7.5rem;
`;

export const skeletonContainer = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const skeletonBottom = css`
  margin-top: 1rem;
  display: flex;
  flex: 1 1 auto;
`;

export const nonOwnerText = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  text-align: center;
  justify-content: center;
`;

export const okButton = css`
  max-width: 10rem;
`;
